import {
    SALES_ROUTES_LIST,
    SALES_ROUTES_LOADING,
} from '../actions/salesRoutes';

const INITIAL_STATE = {
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 20,
    number: 0,
    loading: false,
};

const salesRoutes = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SALES_ROUTES_LOADING:
            return { ...state, loading: true };
        case SALES_ROUTES_LIST:
            return {
                ...state,
                ...action.list,
                loading: false,
            };
        default:
            return state;
    }
};
export default salesRoutes;
